import DynamicCard from "../../scenes/AccountsAndFinanceManagement/Component/DynamicComponent";
import ImprestApplicationsByUserTable from "../../scenes/HRManagemenet/ImprestByUser";
import ImprestSurrenderTable from "../../scenes/HRManagemenet/ImprestSurrender/surrendar";
import LeaveApplicationsTable from "../../scenes/HRManagemenet/LeaveApplications";
import LeaveApprovalsTable from "../../scenes/HRManagemenet/LeaveApprovals";
import PCApplicationsTable from "../../scenes/HRManagemenet/PettyCash/PCApplications";
import PCApplicationsByUserTable from "../../scenes/HRManagemenet/PettyCash/PCApplicationsByUser";
import StaffClaimsTable from "../../scenes/HRManagemenet/StaffClaim";
import StaffClaimsByUserTable from "../../scenes/HRManagemenet/StaffClaimByUser";
import AssetTypes from "../../scenes/FixedAssetsManagement/AssetSetups/assetsTypes";
import DepreciationMethods from "../../scenes/FixedAssetsManagement/AssetSetups/depreciationMethods";
import DepreciationSchedules from "../../scenes/FixedAssetsManagement/AssetSetups/DepreciationSchedules";
import FixedAssetsCategories from "../../scenes/FixedAssetsManagement/AssetSetups/fixedAssetsCategories";
import ImprestPendingDisbursementTable from "../../scenes/HRManagemenet/ImprestByUser/imprestpendingdisbursement";
import ImprestApprovedDisbursedTable from "../../scenes/HRManagemenet/ImprestByUser/imprestapproval";
import ApprovedImprestSurrendersTable from "../../scenes/HRManagemenet/ImprestByUser/approvedimprestsurrender";
import ClaimPendingDisbursementTable from "../../scenes/HRManagemenet/StaffClaimByUser/claimpendingdisbursement";
import StaffClaimsApprovedTable from "../../scenes/HRManagemenet/StaffClaimByUser/ApprovedClaim";
import PayComponentTable from "../../scenes/HRManagemenet/PayrollSetups/PayComponent/PayComponent";
import StatutoryTable from "../../scenes/HRManagemenet/PayrollSetups/StatutoryComponent/Statutory";
import StatutoryRateTable from "../../scenes/HRManagemenet/PayrollSetups/StatutoryRate/StatutoryRate";
import EmployeePayTable from "../../scenes/HRManagemenet/PayrollSetups/EmployeePayComponent/EmployeePay";
import PayrollTable from "../../scenes/HRManagemenet/Payroll";
import PayrollDeductionTable from "../../scenes/HRManagemenet/Payroll/PayrollDeductionMethods/PayrollDeduction";
import PayrollRunTable from "../../scenes/HRManagemenet/Payroll/PayrollRun/PayrollRunLines";
import LeaveBalancesTable from "../../scenes/HRManagemenet/LeaveApplications/LeaveBalances";
import FeeNote from "../../scenes/ClientInvoicing/FeeNote";
import FeeNotesPendingApprovalTable from "../../scenes/ClientInvoicing/FeeNote/FeeNotePendingApproval";
import FeeNotesPendingApproval from "../../scenes/ClientInvoicing/FeeNote/FeeNotePendingApproval";
import ApprovedFeeNote from "../../scenes/ClientInvoicing/FeeNote/ApprovedFeeNotes";
import ImprestPendingApprovalsTable from "../../scenes/HRManagemenet/ImprestApplications/ImprestApplicationPendingApproval";
import ClaimPendingApprovalsTable from "../../scenes/HRManagemenet/StaffClaimByUser/StaffCoaimPendingApproval";
import PayrollPendingApprovalTable from "../../scenes/HRManagemenet/Payroll/PayrollRun/PayrollRunsPendingApproval";
import PayrollApprovedTable from "../../scenes/HRManagemenet/Payroll/PayrollRun/ApprovedPayrollpendingclosure";
import PayrollPostedTable from "../../scenes/HRManagemenet/Payroll/PayrollRun/PostedPayrollruns";
import CaseCategoryTable from "../../scenes/Setup Management/SystemSetups/CaseCategory";
import CaseSubCategoryTable from "../../scenes/Setup Management/SystemSetups/CaseSubCateory";
import CaseStatusTable from "../../scenes/Setup Management/SystemSetups/CaseStatus";

export const AssetTypesView = () => {
  return (
    <DynamicCard>
      <AssetTypes />
    </DynamicCard>
  );
};

export const DepreciationMethodsView = () => {
  return (
    <DynamicCard>
      <DepreciationMethods />
    </DynamicCard>
  );
};
export const DepreciationSchedulesView = () => {
  return (
    <DynamicCard>
      <DepreciationSchedules />
    </DynamicCard>
  );
};
export const FixedAssetsCategoriesView = () => {
  return (
    <DynamicCard>
      <FixedAssetsCategories />
    </DynamicCard>
  );
};

export const MyImprests = () => {
  return (
    <DynamicCard>
      <ImprestApplicationsByUserTable />
    </DynamicCard>
  );
};
export const ApprovedImprests = () => {
  return (
    <DynamicCard>
      <ImprestApprovedDisbursedTable />
    </DynamicCard>
  );
};

export const ApprovedSurrenders = () => {
  return (
    <DynamicCard>
      <ApprovedImprestSurrendersTable />
    </DynamicCard>
  );
};
export const ImprestSurrender = () => {
  return (
    <DynamicCard>
      <ImprestSurrenderTable />
    </DynamicCard>
  );
};
export const AllPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsTable />
    </DynamicCard>
  );
};

export const MyPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsByUserTable />
    </DynamicCard>
  );
};
export const MyLeaveApplications = () => {
  return (
    <DynamicCard>
      <LeaveApplicationsTable />
    </DynamicCard>
  );
};
export const LeaveBalances = () => {
  return (
    <DynamicCard>
      <LeaveBalancesTable />
    </DynamicCard>
  );
};
export const ApprovedLeaveApplications = () => {
  return (
    <DynamicCard>
      <LeaveApprovalsTable />
    </DynamicCard>
  );
};
export const MyStaffClaims = () => {
  return (
    <DynamicCard>
      <StaffClaimsByUserTable />
    </DynamicCard>
  );
};
export const ClaimsPendingApproval = () => {
  return (
    <DynamicCard>
      <ClaimPendingApprovalsTable />
    </DynamicCard>
  );
};
export const StaffClaimApprovals = () => {
  return (
    <DynamicCard>
      <StaffClaimsApprovedTable />
    </DynamicCard>
  );
};


export const ImprestsPendingDisbursement = () => {
  return (
    <DynamicCard>
      <ImprestPendingDisbursementTable />
    </DynamicCard>
  );
};
export const ImprestPendingApprovals = () => {
  return (
    <DynamicCard>
      <ImprestPendingApprovalsTable />
    </DynamicCard>
  );
};


export const ClaimsPendingDisbursement = () => {
  return (
    <DynamicCard>
      <ClaimPendingDisbursementTable />
    </DynamicCard>
  );
};

export const PayComponent = () => {
  return (
    <DynamicCard>
      <PayComponentTable />
    </DynamicCard>
  );
};

export const Statutory = () => {
  return (
    <DynamicCard>
      <StatutoryTable />
    </DynamicCard>
  );
};

// export const StatutoryRates = () => {
//   return (
//     <DynamicCard>
//       <StatutoryRateTable />
//     </DynamicCard>
//   );
// };

export const PayStructure = () => {
  return (
    <DynamicCard>
      <EmployeePayTable />
    </DynamicCard>
  );
};

export const DraftPayrollRuns = () => {
  return (
    <DynamicCard>
      <PayrollTable />
    </DynamicCard>
  );
}
export const PayrollPendingApproval = () => {
  return (
    <DynamicCard>
      <PayrollPendingApprovalTable />
    </DynamicCard>
  );
}
export const ApprovedPayrollRun = () => {
  return (
    <DynamicCard>
      <PayrollApprovedTable />
    </DynamicCard>
  );
}
export const ClosedPostedPayrollRuns = () => {
  return (
    <DynamicCard>
      <PayrollPostedTable />
    </DynamicCard>
  );
}

export const PendingApprovalFeeNotes = () => {
  return (
    <DynamicCard>
      <FeeNotesPendingApproval />
    </DynamicCard>
  );
};
  export const DraftFeeNotes = () => {
  return (
    <DynamicCard>
      <FeeNote />
    </DynamicCard>
  );
};

  export const ApprovedFeeNotes = () => {
  return (
    <DynamicCard>
      <ApprovedFeeNote />
    </DynamicCard>
  );
};

  export const CaseCategory = () => {
  return (
    <DynamicCard>
      <CaseCategoryTable />
    </DynamicCard>
  );
};
  export const CaseSubCategory = () => {
  return (
    <DynamicCard>
      <CaseSubCategoryTable />
    </DynamicCard>
  );
}

  export const CaseStatus = () => {
  return (
    <DynamicCard>
      <CaseStatusTable />
    </DynamicCard>
  );
}


